import { render } from "./NovaFibra.vue?vue&type=template&id=5872473c"
import script from "./NovaFibra.vue?vue&type=script&lang=js"
export * from "./NovaFibra.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__